module.exports = __webpack_public_path__ + "stylesheets/tabs_88306286070ca704e5590ba518a6d98f.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/tabs.less
// module id = 4eYb
// module chunks = 154